import { logger } from '@ferreri/minato-logger-next';
import {
  customQueryClient,
  QueryClientProvider,
} from '@ferreri/minato-react-utils';
import { clube } from '@ferreri/prever-component-lib';
import { AppProps } from 'next/app';
import { AppLayout } from '@ferreri/prever-component-lib/nextjs';

import 'next/dynamic';
import { Encode_Sans } from 'next/font/google';

import { SETTINGS } from '../config/settings';
import { PAGE_TITLE } from '../utils/pageTitle';

const encodeSans = Encode_Sans({
  subsets: ['latin'],
  weight: [
    '100',
    '200',
    '300',
    '400',
    '500',
    '600',
    '700',
    '700',
    '800',
    '900',
  ],
  variable: '--font-family-01',
});

logger.setBasePath(SETTINGS.public.basePath);

// This default export is required in a new `pages/_app.js` file.
export default function MyApp({ Component, pageProps }: AppProps) {
  return (
    <QueryClientProvider client={customQueryClient}>
      <AppLayout
        productName="ClubeVantagens"
        projectName="Publication"
        tmsToken={SETTINGS.public.tmsToken}
        fontFamily={encodeSans.variable}
        theme={clube}
        defaultTitle={PAGE_TITLE.defaultTitle}
      >
        <Component {...pageProps} />
      </AppLayout>
    </QueryClientProvider>
  );
}
